"use client";
import { ark } from "../factory.js";
import { useCheckboxContext } from "./use-checkbox-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-control.tsx
var CheckboxControl = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useCheckboxContext().getControlProps(), props);
	return /* @__PURE__ */ jsx(ark.div, {
		...mergedProps,
		ref
	});
});
CheckboxControl.displayName = "CheckboxControl";
//#endregion
export { CheckboxControl };
